/**
 * Web needs no bridge: TanStack Query's default `onlineManager` already listens to the browser's
 * `online`/`offline` window events, which is exactly the signal we want there. Present only so the
 * native and web builds share one import specifier.
 */
export function subscribeOnlineManagerToNetworkState(): () => void {
  return () => undefined;
}
